import React, { forwardRef, useState, useEffect } from "react";

const Invoice = forwardRef(({ user, cartItems, formattedDate, getBill }, ref) => {
  const styles = {
    container: {
      width: '100%',
      maxWidth: '80mm',
      margin: '0 auto',
      padding: '0 5px',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      lineHeight: '1.2'
    },
    title: {
      fontSize: '18px',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    invoiceHeading: {
      fontSize: '12px',
      fontWeight: 'semi-bold',
      textAlign: 'center',
      marginTop: '6px',
      marginBottom: '6px'
    },
    billDetails: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 5px',
      lineHeight: '5px',
      marginTop: '3px',
      marginBottom: '3px'
    },
    tableContainer: {
      marginTop: '10px'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse'
    },
    thTd: {
      padding: '4px',
      textAlign: 'left'
    },
    th: {
      fontWeight: 'bold',
      borderTop: '1px solid #000',
      borderBottom: '1px solid #000'
    },
    totalDetails: {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingTop: '10px'
    },
    status: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '10px 0'
    },
    footer: {
      marginTop: '10px',
      textAlign: 'center'
    },
    hr: {
      borderTop: '1px dashed #000',
      margin: '10px 0'
    }
  };

  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const updateCurrentTime = () => {
      const now = new Date();
      const formattedTime = now.toLocaleTimeString();
      setCurrentTime(formattedTime);
    };

    updateCurrentTime();
    const intervalId = setInterval(updateCurrentTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div ref={ref} style={styles.container}>
      <h3 style={styles.title}>
        Brahma Osu - {user.shop.branch}
      </h3>
      <p className="text-xs text-center">Phone: +94 77 791 6063</p>
      <h5 style={styles.invoiceHeading}>
        #INVOICE
      </h5>
      <hr style={styles.hr} />
      <div style={styles.billDetails}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }} className="text-xs">
          <p>Outlet :</p>
          <p>Cashier :</p>
          <p>Date :</p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }} className="text-xs">
          <p>{user.shop.name} ({user.shop.branch})</p>
          <p>{user.full_name}</p>
          <p>{formattedDate} | {currentTime}</p>
        </div>
      </div>

      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={{ ...styles.thTd, ...styles.th }}>Item</th>
              <th style={{ ...styles.thTd, ...styles.th }}>Qty</th>
              <th style={{ ...styles.thTd, ...styles.th }}>Price(LKR)</th>
              <th style={{ ...styles.thTd, ...styles.th }}>Amount(LKR)</th>
            </tr>
          </thead>
          <tbody>
          {cartItems.map((element, index) => (
            <React.Fragment key={index}>
              <tr>
                <td colSpan="4" style={{ ...styles.thTd }}>{element.name}</td>
              </tr>
              <tr>
                <td style={styles.thTd}></td>
                <td style={{ ...styles.thTd }}>{element.neededAmount}</td>
                <td style={{ ...styles.thTd }}>{element.selling_price_per_unit}</td>
                <td style={{ ...styles.thTd }}>{element.total_price_per_units}</td>
              </tr>
            </React.Fragment>
          ))}
          </tbody>
        </table>
        <hr style={styles.hr} />
      </div>
      <div style={styles.totalDetails}>
        <div>
          <div className="flex justify-between">
            <p>Total Amount :</p>
            <p className="w-24 text-right font-semibold">LKR {getBill().total}</p>
          </div>
          <div className="flex justify-between">
            <p>Cash :</p>
            <p className="w-24 text-right">LKR {getBill().cash}</p>
          </div>
          <div className="flex justify-between">
            <p>Balance :</p>
            <p className="w-24 text-right">LKR {(getBill().cash - getBill().total).toFixed(2)}</p>
          </div>
        </div>
      </div>
      <div style={styles.status}>
        <p className="text-xs">Status: <strong>Paid</strong></p>
      </div>
      <hr style={styles.hr} />
      <div className="text-center" style={styles.footer}>
        <small className="font-medium">~THANK YOU FOR YOUR PURCHASE~</small>
        <br />
        <small>Please Contact for any queries related to Invoice.</small><br/>
        <small>© 2024 All Rights Reserved. Soulution by | SimpleCodeICT</small>
      </div>
    </div>
  );
});

export default Invoice;
